import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'babel-polyfill';
import 'raf/polyfill';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/string';


const rootElement = document.getElementById('root');

ReactDOM.render(<App />, rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
